import { Clock3, MessageCircle } from "lucide-react";

export const StoreClosedNotice = ({ status }) => {
  if (!status || status.is_open) {
    return null;
  }

  const emergencyText = encodeURIComponent("Hello, I need help with an emergency order.");

  return (
    <section
      className="mx-auto mb-5 flex max-w-6xl flex-wrap items-center justify-between gap-4 border border-amber-200 bg-amber-50 px-4 py-3 text-amber-950"
      data-testid="store-closed-notice"
    >
      <div className="flex min-w-0 items-start gap-3">
        <Clock3 className="mt-0.5 shrink-0" size={20} aria-hidden="true" />
        <div>
          <p className="font-bold" data-testid="store-closed-message">
            {status.message || "Store is temporarily closed"}
          </p>
          {status.next_opening && (
            <p className="mt-0.5 text-sm" data-testid="store-next-opening">
              Next opening: {status.next_opening}
            </p>
          )}
        </div>
      </div>
      <a
        href={`https://wa.me/917980016662?text=${emergencyText}`}
        target="_blank"
        rel="noreferrer"
        data-testid="emergency-order-whatsapp-link"
        className="inline-flex shrink-0 items-center gap-2 bg-emerald-700 px-3 py-2 text-sm font-bold text-white transition-colors hover:bg-emerald-800"
      >
        <MessageCircle size={17} aria-hidden="true" />
        Emergency Order on WhatsApp
      </a>
    </section>
  );
};